export default "__VITE_ASSET__DLfmXnIM__"